/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'
import _ from 'lodash'

export default class RestaurantField extends React.PureComponent {
  generateDropDownRestaurants = () => {
    const { restaurants } = this.props
    const selectOptions = []

    _.map(restaurants, restaurant => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          label: restaurant.name,
          value: restaurant.key,
        })
      }
    })

    return selectOptions
  }

  render() {
    const { onChange } = this.props

    return (
      <Form.Field required>
        <label>Restaurant</label>
        <Select
          required
          menuPlacement="bottom"
          isSearchable
          placeholder="Please choose restaurant"
          onChange={data => onChange(data.value)}
          options={this.generateDropDownRestaurants()}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/fields/restaurantField.js